import React from 'react';
import { ClickAwayListener as MuiClickAwayListener } from '@material-ui/core';

const ClickAwayListener = props => <MuiClickAwayListener {...props} />;

export default ClickAwayListener;
